import React, {memo} from 'react'
import styled from '@emotion/styled'
import {FilterUrlParams} from 'modules/search/types'
import {isFacetSelected} from 'utils/filters'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'
import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'

const PillWrapper = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s300};
  overflow-y: auto;
  /* This is to make the scrolling area reach the edge of the
   * screen, overriding the parent's padding.
   */
  width: calc(100% + ${cssTheme.layout.spacing.s700});
  margin-top: 0;
  margin-right: ${minus(cssTheme.layout.spacing.s500)};
  margin-bottom: ${minus(cssTheme.layout.spacing.s400)};
  margin-left: ${minus(cssTheme.layout.spacing.s500)};
  padding: 0 ${cssTheme.layout.spacing.s500} ${cssTheme.layout.spacing.s400};
`

interface Props {
  onChange: (
    filterKey: keyof FilterUrlParams,
    filterValue: string | null | undefined
  ) => void
  value: FilterUrlParams['starRatings']
}

const StarRatingFilterComponent: React.FC<Props> = ({onChange, value}) => {
  const starRatings = ['1', '2', '3', '4', '5']

  return (
    <PillWrapper>
      {starRatings.map(rating => {
        const isActive = isFacetSelected(value, rating)
        return (
          <Pill
            key={rating}
            isSelected={isActive}
            iconEnd={<Icon name="StarSolid" />}
            onClick={() => onChange('starRatings', rating)}
          >
            {rating}
          </Pill>
        )
      })}
    </PillWrapper>
  )
}

export const StarRatingFilter = memo(StarRatingFilterComponent)
